<script setup lang="ts">
import { hueOf, initialsOf } from '@codecures/live-stream'

/** A person: their picture, or their initials on a colour that is theirs. A ring while they speak. */
withDefaults(
  defineProps<{
    name: string
    /** Keys the colour, so it stays the same wherever they appear. */
    id?: string
    src?: string | null
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
    speaking?: boolean
  }>(),
  { id: undefined, src: null, size: 'md' },
)
</script>

<template>
  <span
    class="relative inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full font-semibold text-white"
    :class="[
      {
        xs: 'size-6 text-[10px]',
        sm: 'size-8 text-xs',
        md: 'size-10 text-sm',
        lg: 'size-14 text-lg',
        xl: 'size-24 text-3xl',
      }[size],
      speaking ? 'ring-2 ring-success ring-offset-2 ring-offset-transparent' : '',
    ]"
    :style="src ? undefined : { backgroundColor: `hsl(${hueOf(id ?? name)} 45% 45%)` }"
    :aria-label="name"
    role="img"
  >
    <img v-if="src" :src="src" :alt="name" class="size-full object-cover" />
    <template v-else>{{ initialsOf(name) || '?' }}</template>
  </span>
</template>
